import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';

function AuthCallback() {
  const { t } = useTranslation();
  const [status, setStatus] = useState(t('auth.processing') || 'Processing...');
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const processedRef = useRef(false);

  useEffect(() => {
    // Prevent multiple executions (React 18 StrictMode + re-renders)
    if (processedRef.current) {
      console.log('[AuthCallback] Already processed, skipping...');
      return;
    }
    
    const processAuth = async () => {
      processedRef.current = true;
      console.log('[AuthCallback] Starting authentication process...');
      
      try {
        const success = await handleGoogleCallback();
        if (success) {
          console.log('[AuthCallback] ✅ Authentication successful, redirecting to dashboard');
          setStatus(t('auth.successRedirecting') || 'Erfolgreich! Weiterleitung zum Dashboard...');
          // Immediate redirect - user is already authenticated
          navigate('/dashboard', { replace: true });
        } else {
          console.log('[AuthCallback] ❌ Authentication failed, redirecting to login');
          setStatus(t('auth.googleAuthFailed') || 'Google-Authentifizierung fehlgeschlagen. Weiterleitung zum Login...');
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        }
      } catch (error) {
        console.error('[AuthCallback] ❌ Error during authentication:', error);
        setStatus(t('auth.googleAuthFailed') || 'Google-Authentifizierung fehlgeschlagen. Weiterleitung zum Login...');
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      }
    };

    processAuth();
  }, []); // Empty deps - run once on mount only

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-blue-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p className="text-lg text-gray-700">{status}</p>
      </div>
    </div>
  );
}

export default AuthCallback;